export default __webpack_public_path__ + "static/media/t-curriculum.d2a4e414.svg";